import Axios from 'axios'
import Store from '../store/store'
import Router from '../router/index'
import Qs from 'qs'
import { baseUrls } from '../settings.js'
import { EventBus, ORCAMENTO_EDIT_FORBIDDEN_EVENT } from '../helpers/eventBus'

var httpNoLoadingPendingRequestList = [];

const httpNoLoadingFunctions = {
    cancelPendingRequests: function () {
        httpNoLoadingPendingRequestList.forEach((item) => {
            item.cancel("Request canceled in axios-config(no loading)...");
        });
        httpNoLoadingPendingRequestList = [];
    }
};

const httpNoLoading = Axios.create({
    baseURL: baseUrls.api,
    headers: {
        'Content-Type': 'application/json'
    },
    paramsSerializer: function (params) {
        return Qs.stringify(params, { arrayFormat: 'brackets' })
    },
})

httpNoLoading.interceptors.request.use(
    config => {
        config.headers['X-Api-Key'] = Store.state.login.xApiKey;
        let source = Axios.CancelToken.source();
        config.cancelToken = source.token;
        httpNoLoadingPendingRequestList.push(source);
        return config;
    },
    error => {
        return Promise.reject(error)
    }
);

httpNoLoading.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (
        error.response &&
        error.response.status === 403 &&
        error.response.data &&
        error.response.data.code === 'ORCAMENTO_EDIT_FORBIDDEN'
    ) {
        EventBus.$emit(ORCAMENTO_EDIT_FORBIDDEN_EVENT);
    }
    if (error.response && error.response.status === 401) {
        if (!Router.currentRoute.path.includes('login')) {
            Store.commit('ui/MSG', error.response.data.msg);
            Store.commit('ui/MSG_TYPE', error.response.data.type);
            Router.push("/login");
        }
    }
    return Promise.reject(error);
});

export { httpNoLoading };
export { httpNoLoadingFunctions };
